import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';

const Experience = () => {
  const { t } = useLanguage();

  return (
    <Section id="experience" bg="bg-brand-dark">
      <div className="max-w-4xl mx-auto">
        <SectionHeading className="text-center">{t.experience.heading}</SectionHeading>
        
        <div className="space-y-6 text-lg text-brand-text text-center mt-12 mb-16 max-w-3xl mx-auto">
          {t.experience.body.map((p, i) => <p key={i} className="leading-relaxed">{p}</p>)}
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {t.experience.tags.map((tag, i) => (
            <span 
              key={i} 
              className="px-4 py-2 bg-brand-card border border-brand-border rounded-full text-sm font-medium text-brand-textHover hover:text-white hover:border-brand-textMuted transition-colors cursor-default"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Experience;